import Vue from 'vue'
import store from './store'

// 按钮上判断是否拥有权限
const hasPermission = (needPermission) => {
  const userInfo = store.state.user
  if (userInfo && userInfo.urlSet && needPermission) {
    const needPermissions = needPermission.split(',')
    return userInfo.urlSet.some(role => needPermissions.indexOf(role) != -1)
  } else {
    return false
  }
}
Vue.prototype.$hasPermission = hasPermission

// 在vue上挂载一个指令 preventReClick
// 防止按钮重复点击
const preventReClick = Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 800)
        // binding.value可以自行设置。如果设置了则跟着设置的时间走
        // 例如：v-preventReClick='500'
      }
    })
  }
})

export { preventReClick }
